import { apiGet } from '../../fetch/apiService';

export const getDataSourceVariables = (dataSourceId) => {
	return apiGet(`datasource-text-variables/${dataSourceId}`,null, { internalApi: true });
};
